import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {BodySmall} from '@spaced-out/ui-design-system/lib/components/Text';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {formatDuration} from '../../../utils/sequential';
import type {MeetingStats} from '../../../utils/sequential';
import css from './sequential-booking-info.css';


interface BookingStatsProps {
  stats: MeetingStats;
}

export const BookingStats = ({stats}: BookingStatsProps) => {
  const {t} = useLabelTranslation();

  if (stats.isMultiDay) {
    return (
      <div className={css.bookingStats}>
        <div className={css.statItem}>
          <Icon
            name="calendar"
            size="small"
            color="tertiary"
            type="regular"
            testId="days-icon"
          />
          <BodySmall color="secondary">
            {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
            {stats.totalDays} {t('days_schedule', 'days schedule')}
          </BodySmall>
        </div>
      </div>
    );
  }

  return (
    <div className={css.bookingStats}>
      <div className={css.statItem}>
        <Icon
          name="clock"
          size="small"
          color="tertiary"
          type="regular"
          testId="duration-icon"
        />
        <BodySmall color="secondary">
          {formatDuration(stats.totalHours, stats.totalMinutes, t)}
        </BodySmall>
      </div>
      <div className={css.statItem}>
        <Icon
          name="layer-group"
          size="small"
          color="tertiary"
          type="regular"
          testId="rounds-icon"
        />
        <BodySmall color="secondary">
          {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
          {stats.totalRounds}{' '}
          {stats.totalRounds === 1
            ? t('Round', 'Round')
            : t('Rounds', 'Rounds')}
        </BodySmall>
      </div>
    </div>
  );
};
